<template>
  <div
    class="social_media d-flex flex-column justify-content-between align-items-center pt-2 mb-4 mb-md-4"
  >
    <div class="follow">
      <p class="jaapokki mt-md-3 mt-2 center-text">Follow us</p>
    </div>
    <div>
      <a href="#" aria-label="link to facebook" class="footer-icon">
        <i class="fab fa-facebook-f fa-lg white-text mx-2"> </i>
      </a>
      <a href="#" aria-label="link to instagram" class="footer-icon">
        <i class="fab fa-instagram fa-lg white-text mx-2"> </i>
      </a>
      <a
        href="https://www.tiktok.com/@youcanlearn.app?lang=en"
        aria-label="link to whatsapp"
        class="footer-icon"
      >
        <i class="fab fa-tiktok fa-lg white-text mx-2"> </i>
      </a>
    </div>

    <div></div>

    <div>
      <a
        href="https://fr.linkedin.com/company/you-can-learn-app"
        aria-label="link to linkedin"
        class="footer-icon"
      >
        <i class="fab fa-linkedin-in fa-lg white-text mx-2"> </i>
      </a>

      <a
        href="https://x.com/YCLA_france"
        aria-label="link to pinterest"
        class="footer-icon"
      >
        <i class="fab fa-twitter fa-lg white-text mx-2"> </i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialMedia",
};
</script>

<style lang="scss" scoped>
.follow {
  & p {
    font-size: 1.25rem;
  }
  & .hr {
    width: 100%;
    height: 2px;
    background: $color-primary;
    overflow: hidden;
    margin-bottom: 10px;
    margin-top: 5px;
  }
}
.social_media {
  & div {
    margin: 5px;
  }
  & i:not(.fa-facebook-f) {
    width: 37px;
    color: $color-primary;
    background: rgba($color: $color-secondary, $alpha: 0.3);
    padding: 9px;
    border-radius: 10px;
  }
  & .fa-facebook-f {
    width: 37px;
    color: $color-primary;
    background: rgba($color: $color-secondary, $alpha: 0.3);
    padding: 9px 11px;
    border-radius: 10px;
    &:hover {
      background: #3b5998;
      color: $color-text;
    }
  }
  & .fa-instagram:hover {
    background: #d6249f;
    background: radial-gradient(
      circle at 30% 107%,
      #fdf497 0%,
      #fdf497 5%,
      #fd5949 40%,
      #d6249f 60%,
      #285aeb 95%
    );
    color: $color-text;
  }
  & .fa-twitter:hover {
    background: #1da1f2;
    color: $color-text;
  }
  & .fa-tiktok:hover {
    background-color: #000000;
    color: $color-text;
  }
  & .fa-snapchat-ghost:hover {
    background: #fffb00bd;
    color: $color-text;
  }
  & .fa-linkedin-in:hover {
    background: #007bb5;
    color: $color-text;
  }
  & .fa-twitter:hover {
    background: #08bddd;
    color: $color-text;
  }
}
</style>
